import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import Billboard from './Billboard';
export const CustomBillboard = (props) => {
    const { follow = false, lockY: _lockY = false, children, isCameraOrbiting: _orbit = false, ...groupProps } = props;
    return (_jsx(_Fragment, { children: !follow ?
            _jsx("group", { ...groupProps, children: children }) :
            _jsx(Billboard, { ...props, children: children }) }));
};
export default CustomBillboard;
